function titleCase(value) {
  return String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function formatLocation(loc) {
  if (!Array.isArray(loc)) return "";
  const parts = loc.filter((part) => !["body", "query", "path"].includes(String(part)));
  return parts.length ? parts.join(".") : "";
}

function stringifyDetail(detail) {
  if (!detail) return "";
  if (typeof detail === "string") return detail;
  if (typeof detail === "number" || typeof detail === "boolean") return String(detail);

  if (Array.isArray(detail)) {
    return detail
      .map((entry) => {
        if (typeof entry === "string") return entry;
        if (!entry || typeof entry !== "object") return String(entry || "");
        const message = stringifyDetail(entry.msg || entry.message || entry.detail || entry.error);
        const loc = formatLocation(entry.loc);
        if (loc && message) return `${loc}: ${message}`;
        return message || stringifyDetail({ ...entry, loc: undefined });
      })
      .filter(Boolean)
      .join("; ");
  }

  if (typeof detail === "object") {
    const preferred = detail.message || detail.msg || detail.error || detail.detail;
    if (preferred && preferred !== detail) return stringifyDetail(preferred);

    return Object.entries(detail)
      .filter(([, value]) => value !== undefined && value !== null && value !== "")
      .map(([key, value]) => `${titleCase(key)}: ${stringifyDetail(value)}`)
      .filter(Boolean)
      .join("; ");
  }

  return "";
}

export function getApiErrorMessage(err, fallback = "Request failed. Please try again.") {
  const fallbackMessage = typeof fallback === "string" && fallback.trim() ? fallback : "Request failed. Please try again.";

  if (!err) return fallbackMessage;
  if (typeof err === "string") return err;

  if (err.userMessage && typeof err.userMessage === "string") return err.userMessage;

  const data = err.response?.data;
  const detailMessage = stringifyDetail(data?.detail);
  if (detailMessage) return detailMessage;

  const dataMessage = stringifyDetail(data?.message || data?.error);
  if (dataMessage) return dataMessage;

  if (!err.response && (err.code === "ERR_NETWORK" || err.message === "Network Error" || err.request)) {
    return "Unable to reach the EHS server. Please try again or contact an administrator.";
  }

  if (typeof err.message === "string" && err.message.trim()) return err.message;
  return fallbackMessage;
}

export default getApiErrorMessage;
